(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('sms', ['$rootScope', '$translate', 'SharedAgendaService', 'CallsService', 'TextMessageService', 'Alert', 'HelperService', '$uibModalStack', 'UserService', 'UserContactInfoTypeEnum', SMSDirectiveFn]);

    /* sms directive */
    function SMSDirectiveFn($rootScope, $translate, SharedAgendaService, CallsService, TextMessageService, Alert, HelperService, $uibModalStack, UserService, UserContactInfoTypeEnum)  {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/ringfoon/templates/sms.template.html',
            scope: true
        };
        return directive;

        function link(scope, element) {


            // sms
            scope.sms = {
                content: null  // text-message-content
            };


            activate();

            // activate directive
            function activate() {
                // clear
                scope.sms.content = null;
                // only for MOBILE
                if (CallsService.outgoing.contactInfoType !== "2") {
                    element.remove();
                    return;
                } // if

                // sms (need prefix on Ringfoon-User)
                if ($rootScope.isRingfoon) {
                    $translate('message_from').then(function (translation) {
                        SharedAgendaService.isLoading().then(function () {
                            let currentAgendaOwner = SharedAgendaService.currentUser();
                            UserService.getPhoneNumberForCommunication(currentAgendaOwner.id).then(phoneNumber => {
                                let caption = CallsService.outgoing.agendaCaption || currentAgendaOwner.caption;
                                scope.sms.content = `${translation} ${caption} ${phoneNumber ? ` - ${phoneNumber}` : ''}:`;
                            });
                        });
                    });
                } // if

            } // activate

            // send sms
            scope.send = function () {
                // block
                HelperService.block(element);
                // send
                TextMessageService.send(CallsService.outgoing.phonenumber, scope.sms.content).then(function (result) {
                    Alert.success(result);
                    activate();
                    HelperService.unblock(element);
                    $uibModalStack.dismissAll();
                }, function() {
                    HelperService.unblock(element);
                });
            };

        } // link
    }
})();